import Vue from 'vue'
import Router from 'vue-router'
import Hello from '@/components/Hello'
import StartSurvey from '@/components/StartSurvey'
// import CustomerSurvey from '@/components/CustomerSurvey'
import Generic from '@/components/Generic'
import Question from '@/components/Question'
import Thankyou from '@/components/Thankyou'
import Final from '@/components/Final'
import CustomerFinal from '@/components/CustomerFinal'
import Submit from '@/components/Submit'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Hello',
      component: Hello
    },
    {
      path: '/generic',
      name: 'generic',
      component: Generic
    },
    // {
    //   path: '/customer/:link',
    //   name: 'customersurvey',
    //   component: CustomerSurvey
    // },
    {
      path: '/survey/:link',
      name: 'survey',
      component: StartSurvey
    },
    {
      path: '/question/:link?/:qno',
      name: 'question',
      component: Question
    },
    {
      path: '/submit/:link?',
      name: 'submit',
      component: Submit
    },
    {
      path: '/final/:link?',
      name: 'final',
      component: Final
    },
    {
      path: '/customerfinal/:link?',
      name: 'customerfinal',
      component: CustomerFinal
    },
    {
      path: '/thankyou/:link?',
      name: 'thankyou',
      component: Thankyou
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js